import React from "react";
import { Dropdown, Menu } from "antd";
import moment from "moment";
import { Icon } from "Components";
import { CampaignData } from "../PhishingManager";

export interface CampaignItem {
  id: number;
  name: string;
  image_url: string;
  status: string;
  schedule_datetime: string;
  campaign_duration: number | string;
}

interface StatusStyle {
  background: string;
  color: string;
}

interface CampaignListProps {
  campaigns: CampaignData[];
  statusStyles: Record<string, StatusStyle>;
  onMenuClick: (campaignId: string) => (e: any) => void;
}

const CampaignList: React.FC<CampaignListProps> = ({
  campaigns,
  statusStyles,
  onMenuClick,
}) => {
  return (
    <div className="pm-campaigns-card">
      {campaigns.map((item) => (
        <div className="pm-card-row" key={item.id}>
          <div className="pm-card-icon">
            <img
              width="80"
              height="80"
              alt={item.name}
              src={item.image_url}
            />
          </div>

          <div className="campaign-card">
            <div className="pm-campaign-card">{item.name}</div>

            <div
              className="campaign-card-wrapper"
              style={{
                background:
                  statusStyles[item.status]?.background ?? "transparent",
              }}
            >
              <span
                className="campaign-card-status"
                style={{
                  color: statusStyles[item.status]?.color ?? "#000",
                }}
              >
                {item.status}
              </span>
            </div>

            <div className="pm-row-stretch">
              <Icon type="campaignCalendar" />
              <span className="pm-card-date">
                {`${moment(item.schedule_datetime).format("M/D/YYYY")} - ${moment(
                  item.schedule_datetime
                )
                  .add(Number(item.campaign_duration), "days")
                  .format("M/D/YYYY")}`}
              </span>
            </div>
          </div>

          <Dropdown
            placement="bottomRight"
            overlayClassName="pm-custom-dropdown-overlay"
            overlay={
              <Menu
                onClick={onMenuClick(item.id.toString())}
                className="pm-custom-dropdown-menu"
              >
                <Menu.Item key="send" className="pm-custom-menu-item">
                  Send full campaign
                </Menu.Item>
                <Menu.Item key="rerun" className="pm-custom-menu-item">
                  Re-run test
                </Menu.Item>
                <Menu.Item key="view" className="pm-custom-menu-item">
                  View setup summary
                </Menu.Item>
                <Menu.Item key="discard" className="pm-custom-menu-item">
                  Discard campaign
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <div className="pm-icon-button">
              <div className="pm-icon">⋯</div>
            </div>
          </Dropdown>
        </div>
      ))}
    </div>
  );
};

export default CampaignList;